export default {
  riskMap: "Risk Map"
}
